export default __webpack_public_path__ + "static/media/fortifyingempowerment.7d6739ee.png";